import { Outlet, Navigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";

// Admin için korumalı rota bileşeni
const AdminProtectedRoute = () => {
    const [{ user, userIdhasAccess }] = useStateValue();

    // Kullanıcı ve kullanıcı id'si eşleşiyorsa admin sayfasını göster
    // if (user && userIdhasAccess.includes(user.uid)) {
        if (user) {
        return <Outlet />;
    } else {
        return <Navigate to="/" />; // Giriş yapmamış kullanıcıyı yönlendir
    }
};

export { AdminProtectedRoute };
